import React from 'react'
import ListPage from 'components/cases/listpage/ListPage'

export const categoryTitle = 'プロダクトマネジメント'
export const baseUrl = '/cases/product-management'

const ProductManagement: React.FC = () => {
  return <ListPage categoryTitle={categoryTitle} baseUrl={baseUrl} pageId={1} />
}

export default ProductManagement
